import { property, makelaar } from "../data/property";
import { ExternalLink } from "lucide-react";
import { trackEvent } from "../lib/analytics";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-brand-bg border-t border-brand-border">
      <div className="mx-auto max-w-[1600px] px-6 py-16 md:px-12 lg:px-20">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <p className="font-serif text-3xl text-brand-ink">{property.address}</p>
            <p className="mt-2 text-sm text-brand-muted">
              {property.postalCode} {property.city}
            </p>
            <p className="mt-6 max-w-md text-sm leading-relaxed text-brand-muted">
              Deze landingspagina is met zorg samengesteld om u een eerste indruk te geven van deze prachtige twee-onder-één-kapwoning. Voor de volledige documentatie verwijzen wij u naar Funda.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="overline">Verkoper</p>
            <p className="mt-4 font-serif text-xl text-brand-ink">{makelaar.name}</p>
            <p className="mt-1 text-sm text-brand-muted">{makelaar.title}</p>
            <a
              data-testid="footer-tel"
              href={`tel:${makelaar.phoneClean}`}
              className="mt-4 block text-sm text-brand-ink hover:text-brand-moss"
            >
              {makelaar.phone}
            </a>
            <a
              data-testid="footer-mail"
              href={`mailto:${makelaar.email}`}
              className="mt-1 block text-sm text-brand-ink hover:text-brand-moss"
            >
              {makelaar.email}
            </a>
          </div>

          <div className="md:col-span-4">
            <p className="overline">Meer informatie</p>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <a
                  data-testid="footer-funda-link"
                  href={property.fundaUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => trackEvent("outbound_click", { location: "footer", destination: "funda_listing" })}
                  className="inline-flex items-center gap-2 text-brand-ink hover:text-brand-moss"
                >
                  Bekijk volledige listing op Funda
                  <ExternalLink size={12} />
                </a>
              </li>
              <li>
                <a
                  data-testid="footer-makelaar-website"
                  href={makelaar.website}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-brand-ink hover:text-brand-moss"
                >
                  Makelaarskantoor — website
                  <ExternalLink size={12} />
                </a>
              </li>
              <li>
                <a
                  data-testid="footer-funda-makelaar"
                  href={makelaar.fundaProfile}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-brand-ink hover:text-brand-moss"
                >
                  Profiel & beoordelingen op Funda
                  <ExternalLink size={12} />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-brand-border pt-8 text-xs text-brand-muted md:flex-row md:items-center">
          <p>
            © {new Date().getFullYear()} {makelaar.name}. Alle foto's en woninggegevens zijn afkomstig van Funda.
          </p>
          <p>
            Vraagprijs {property.price} {property.priceSuffix} · {property.pricePerM2}/m²
          </p>
        </div>
      </div>
    </footer>
  );
}
